/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Loadable } from "components/Loadable";
import { MainLayout } from "layout/MainLayout";
import { lazy } from "react";
import { NavigationContextWrapper } from "sections/navigation-context-wrapper";
import { AuthGuard } from "utils/route-guard/AuthGuard";
import { PermissionContextWrapper } from "./permission-context-wrapper";
// Routes
import { composerRoutes } from "sections/composer/composer-route";
import { dashboardRoutes } from "sections/dashboard/dashboard-routes";
import { digitalAssetsRoutes } from "sections/digital_assets/digital-assets-routes";
import { formsRoutes } from "sections/forms/forms-route";
import { messagingRoutes } from "sections/messaging/messaging-route";
import { settingsRoutes } from "sections/settings/settings-route";
import { profileRoutes } from "sections/profile/profile-route";
import { taskRoutes } from "sections/tasks/tasks-route";
import { websiteRoutes } from "sections/website/website-route";
import { modelRoutes } from "sections/models/models-route";
// import { organizationRoutes } from "sections/organization/organization-route";
// import { componentRoutes } from "sections/components/components-route";
// import { dataRoutes } from "sections/data/data-route";
// import { styleGuideRoutes } from "sections/style-guide/style-guide-routes";
// import { testingRoutes } from "sections/testing/testing-route";


// -------------------------------------------------------
//    Menu Options are found in Menu-Config
//    sections/menu-config
// -------------------------------------------------------

const Dashboard = Loadable(lazy(() => import("sections/dashboard/index")));

const root = [
    {
        path: "/",
        element: <Dashboard />,
    },
];

const MainRoutes = {
    path: "/",
    element: (
        <AuthGuard>
            <NavigationContextWrapper>
                <PermissionContextWrapper>
                    <MainLayout />
                </PermissionContextWrapper>
            </NavigationContextWrapper>
        </AuthGuard>
    ),
    children: [
        ...root,
        ...dashboardRoutes,
        ...taskRoutes,
        ...composerRoutes,
        ...websiteRoutes,
        ...messagingRoutes,
        ...formsRoutes,
        ...digitalAssetsRoutes,
        // ...organizationRoutes,
        ...settingsRoutes,
        ...profileRoutes,
        ...modelRoutes,
        // ...componentRoutes,
        // ...dataRoutes,
    ],
};

export { MainRoutes };
